import { render, staticRenderFns } from "./home-travel-manager.vue?vue&type=template&id=356d6319&scoped=true"
var script = {}
import style0 from "./home-travel-manager.vue?vue&type=style&index=0&id=356d6319&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356d6319",
  null
  
)

export default component.exports